/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 限时抢券活动
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetLimitCouponActivityParams {
  constructor(public activityId: string) {}
}

export default async function (
  params: GetLimitCouponActivityParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.ActivityLimitCouponDetailDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/cms/getLimitCouponActivity`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
